import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';

const PageContainer = styled(Grid).withConfig({ componentId: 'sc-1ovjzdj-0' })`
  max-width: 1024px;
  margin: auto;
`;

export default PageContainer;
